var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

import { Line } from 'react-chartjs-2';
import React from 'react';
import { getPriceRangeInfo } from '../../services/charts';
export var fetchHeaders = function fetchHeaders(columnDef) {
  var column = columnDef;
  var datasets = [];
  var children = column.children;

  if (children) {
    children.forEach(function (child) {
      var results = null;

      if (Array.isArray(child.children) && child.children.length > 0) {
        results = fetchHeaders(child);
        datasets.push.apply(datasets, __spread(results));
      } else {
        datasets.push(child.field);
      }
    });
    return datasets;
  }

  return columnDef && columnDef.field ? [columnDef.field] : [];
};
export var chartColors = {
  1: '#E65100',
  2: '#039BE5',
  3: '#D81B60',
  4: '#43A047',
  5: '#FBC02D',
  6: '#3F51B5',
  7: '#D32F2F',
  8: '#F9A825',
  9: '#9C27B0',
  10: '#C0CA33',
  11: '#AD1457',
  12: '#00796B',
  13: '#283593',
  14: '#9A0007',
  15: '#0277BD',
  16: '#BB4D00',
  17: '#7CB342',
  18: '#6A1B91',
  19: '#0097A7',
  20: '#B91400',
  21: '#99AA00'
};
export var sortArrayCompareFunction = function sortArrayCompareFunction(a, b) {
  a = parseInt(a, 10);
  b = parseInt(b, 10); // eslint-disable-next-line no-nested-ternary

  return a > b ? 1 : b > a ? -1 : 0;
};
export var emptyChart = React.createElement("div", null, React.createElement("div", {
  className: "outer-no-data"
}, React.createElement("div", {
  className: "no-chart-data-div"
}, "No data to show")), React.createElement("div", {
  style: {
    opacity: '0.4'
  }
}, React.createElement(Line, {
  data: {
    datasets: [],
    labels: [20, 40, 60, 80, 100]
  }
})));
export var getPriceRangeForContract = function getPriceRangeForContract(contract, sku, currency) {
  var buyer = contract.buyer,
      seller = contract.seller;
  var options = {
    skuList: [sku],
    sellerId: seller.sellerId,
    buyerId: buyer.buyerId,
    includeAttributesInfo: false,
    currency: currency ? currency.value : undefined
  };
  return getPriceRangeInfo(options);
};
export var getPriceRangeForCatalog = function getPriceRangeForCatalog(seller, sku, currency) {
  var options = {
    skuList: [sku],
    sellerId: seller.sellerId,
    includeAttributesInfo: false,
    currency: currency ? currency.value : undefined
  };
  return getPriceRangeInfo(options);
};